/**
 * Styled Components - Created by jorge on 01/08/18.
 */
import styled from 'styled-components'
import { BLACK_BG } from '../../theme/colors'

interface DivProps {
  secondary?: boolean
  preview?: boolean
  url?: string
  third?: boolean
}

export const Container = styled.div`
  background-color: #fff;
  display: flex;
  flex-flow: column;
  align-items: center;
  width: 100%;
  padding-top: 40px;
  @media (max-width: 900px) {
    justify-content: flex-start;
  }
`

export const JakrooLogo = styled.img`
  max-width: 239px;
  width: 100%;
  margin-bottom: 32px;
`

export const HowToMeasureContainer = styled.div`
  display: flex;
  flex-direction: column;
  margin-block: 24px 100px;
  h1 {
    color: #302628;
    text-align: center;
    font-family: "Avenir Next";
    font-size: 22px;
    font-weight: 600;
    margin-bottom: 40px;
  }
  @media (max-width: 698px) {
    padding: 0 30px 60px;
    width: 100%;
    h1 {
      max-width: 258px;
      margin: 0 auto 16px;
    }
  }
`

export const ChecklistContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  max-width: fit-content;
  font-family: "Avenir Next";
  @media (max-width: 900px) {
    max-width: 100%;
  }
`

// Container for the check list cards (flex row, each card is 50%)
export const ChecklistRow = styled.div`
  display: flex;
  flex-wrap: wrap;
  margin-top: 24px;
  width: 100%;
  justify-content: space-between;
  > div {
    flex-basis: 48%;
  }
  > div:nth-child(2) {
    margin-left: 32px;
  }
  @media (max-width: 900px) {
    flex-direction: column;
    flex-wrap: nowrap;
    align-items: center;
    justify-content: flex-start;
    > div {
      flex-basis: 100%;
      width: 100%;
      margin-left: 0 !important;
      @media (max-width: 320px) {
        margin-inline: 8px !important;
      }
    }
  }
`

// Each checklist card takes 50% (minus margin for gap)
export const ChecklistCard = styled.div`
  padding-inline: 22px;
  display: flex;
  flex-direction: column;
  min-width: 260px;
  max-width: 408px;
  width: 100%;
  min-height: 548px;
  position: relative;
  align-items: flex-start;
  flex-shrink: 0;
  margin-bottom: 24px;
  border-radius: 20px;
  border: 2px solid #E8E5E5;
  background: #FFF;
  font-family: "Avenir Next";
  &[data-min-height="none"] {
    min-height: unset;
    max-width: 386px;
    padding-inline: unset;
    cursor: pointer;
  }
  &[data-checked="true"] {
     border: 3px solid #34c759;
  }
  &[data-has-error="true"] {
    border: 3px solid red;
  }
  @media (max-width: 900px) {
    min-height: auto;
    max-width: 100%;
  }
  @media (max-width: 320px) {
    min-height: auto;
  }
  @media (max-height: 832px) {
    min-height: fit-content;
  }
`

export const ChecklistHeaderContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  height: 56px;
  padding-inline: 22px;
`

export const ChecklistSubtitle = styled.div`
  color: #817E7E;
  font-family: "Avenir Next";
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
  border-top: 1px solid #D7D1D2;
  background: #FFF;
  span {
    display: block;
    margin-block: 10px;
    margin-inline: 16px;
  }
`

// Step indicator circle at the top left with number inside
export const StepIndicator = styled.div`
  width: 34px;
  height: 34px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #302628;
  color: #FFF;
  font-family: "Avenir Next";
  font-size: 12px;
  font-weight: 700;
  &.secondary {
    width: 80%;
    border-radius: 25px;
    margin-bottom: 14px;
    font-weight: normal;
    height: 44px;
    font-size: 14px;
  }
  &[data-bg="none"] {
    background: none;
    color: #000;
    font-size: 28px;
  }
`

export const ChecklistTitle = styled.div`
  margin-left: 12px;
  line-height: 28px;
  text-align: left;
  text-transform: uppercase;
  color: #8F8889;
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 1px;
  &[data-color-black] {
    color: #000;
  }
`

// Card main image
export const ChecklistImage = styled.img`
  height: 307px;
  flex-shrink: 0;
  align-self: stretch;
  object-fit: cover;
  margin-inline: -22px;
  &[data-bottom-rounded="true"] {
    border-bottom-left-radius: 20px;
    border-bottom-right-radius: 20px;
    height: 316px;
    margin-inline: 0px;
  }
  @media (max-width: 698px) {
    height: clamp(220px, 62vw, 264px) !important;
  }
  @media (max-height: 832px) {
    height: 290px;
  }
`

// List of todo/check items below the image
export const ChecklistTodos = styled.ul`
  list-style: none;
  padding: 0;
  margin: 20px 0 2px 0;
  @media (max-width: 320px) {
    margin: 16px 0 10px 0;
  }
  @media (max-height: 832px) {
    margin: 12px 0 2px -6px;
  }
`

export const ChecklistTodoItem = styled.li`
  padding-left: 0px;
  font-size: 14px;
  margin-bottom: 10px;
  display: flex;
  align-items: flex-start;
  color: #625F5F;
  font-weight: 400;
  line-height: 18.2px;
  @media (max-width: 320px) {
    font-size: 13px;
    margin-left: -10px;
  }
  @media (max-height: 832px) {
    margin-bottom: 8px;
  }
  &:before {
    content: '✓';
    display: inline-flex;
    height: 18px;
    margin-right: 8px;
    padding: 2px 4.83px 2px 5.17px;
    justify-content: center;
    align-items: center;
    border-radius: 9px;
    background: rgba(22, 163, 74, 0.10);
    color:  #34C759;
    font-family: "Lucida Grande";
    font-size: 10px;
    font-weight: 600;
    line-height: 14px; /* 140% */
  }
`

// Footer with custom styled checkbox and label
export const ChecklistFooter = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  margin-top: auto;
  padding-inline: 22px;
  border-top: 1px solid #ececec;
  width: calc(100% + 44px);
  height: 56px;
  margin-inline: -22px;
  border-bottom-left-radius: 14px;
  border-bottom-right-radius: 14px;
  &[data-checked="true"] {
    background: #34c759;
    border-color: #34c759;
  }
  &[data-has-error="true"] {
    background: red;
    border-color: red;
  }
  @media (max-height: 832px) {
    height: 52px;
    margin-top: 0px;
  }
`

export const ChecklistCheckbox = styled.input.attrs({ type: 'checkbox' })`
  accent-color: #34c759;
  width: 22px;
  height: 22px;
  margin-left: 2px;
  margin-right: 12px;
  cursor: pointer;
  position: relative;

  appearance: none; /* Remove default checkbox styles */
  -webkit-appearance: none;
  border-radius: 7px;
  border: 2px solid #D1D5DB;
  background: #FFF;

  /* When checked, fill with green */
  &:checked {
    background: #34c759;
    border-color: #34c759;
  }
`

export const ChecklistCheckboxWrapper = styled.div`
  position: relative;
  display: inline-flex;
  align-items: center;
`

export const ChecklistCheckboxIcon = styled.div`
  position: absolute;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  pointer-events: none;

  .anticon {
    font-size: 16px;
    color: #302628;
  }
`

export const ChecklistCheckboxLabel = styled.label`
  font-size: 15px;
  user-select: none;
  cursor: pointer;
  color: #302628;
  font-size: 16px;
  font-weight: 600;
`

export const ChecklistFootnote = styled.div`
  color: #A8A0A1;
  font-size: 13px;
  font-weight: 400;
  line-height: 20px;
  margin-top: -18px;
  margin-bottom: 20px;
  @media (max-width: 698px) {
    margin-inline: 22px !important;
    margin-top: 0px;
  }
  @media (max-width: 320px) {
    font-size: 12px;
    margin-inline: 10px !important;
  }
  @media (max-height: 832px) {
    margin-top: -12px;
  }
`

export const CarousselContainer = styled.div`
  width: 70%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  padding-top: 20px;
  font-family: "Avenir Next";
  .muted-text {
    color: #A8A0A1;
    font-size: 13px;
    font-weight: 400;
    margin-bottom: 8px;
    @media (max-height: 832px) {
      margin-bottom: 2px;
    }
  }
  .muted-text[data-has-error="true"] {
    color: #C91731;
  }
  .muted-text[data-has-error="false"] {
    color: #A8A0A1;
  }
  .carousel-bottom-actions {
    width: 90%;
    align-items: flex-end;
    justify-content: space-between;
    padding-block: 20px;
    @media (max-width: 698px) {
      width: 100%;
      padding: 10px 10px 16px 10px;
      position: sticky;
      bottom: 0px;
      height: unset;
      border-top: 1px solid #B3B3B3;
      background: white;
    }
    @media (max-height: 832px) {
      padding-top: 8px;
      padding-bottom: 16px;
    }
  }
  .get-measured-bottom-actions {
    @media (min-width: 699px) {
      position: sticky;
      bottom: 0;
      background: white;
      z-index: 999;
      border-top: 1px solid #B3B3B3;
    }
    @media (max-width: 698px) {
      flex-direction: column;
      align-items: center;
    }
  }
  .carousel-bottom-actions.get-measured-bottom-actions .bottom-actions-container .close {
    @media (max-width: 698px) {
      width: 90px !important;
    }
  }
  #get-measured-title {
    width: 728px;
    color: #000;
    text-align: center;
    font-size: 22px;
    font-style: normal;
    font-weight: 600;
    line-height: normal;
    &.before-your-scan {
      color: #302628;
      letter-spacing: -0.84px;
      @media (max-height: 832px) {
        margin-bottom: 6px;
      }
    }
    @media (max-width: 698px) {
      font-size: 22px;
      width: 346px;
    }
    @media (max-width: 320px) {
      font-size: 22px;
      width: 300px;
    }
  }
  #manualBtn {
    max-width: 230px;
    margin-top: 8px;
    margin-right: 12px;
    text-decoration: underline;
    color: #302628;
    font-size: 14px;
    font-weight: 600;
    text-align: center;
    &:hover {
      cursor: pointer;
    }
    &[data-mobile="true"] {
      display: none;
    }
    &[data-mobile="false"] {
      max-width: 100%;
      margin-right: 22px;
      margin-bottom: 10px;
      font-size: 14px;
      @media (max-width: 320px) {
        margin-bottom: 0px;
      }
    }
  }
  #take-photos-wrapper {
    display: flex;
    flex-direction: column;
    align-items: center;
  }
  @media (max-width: 698px) {
    padding-block: 20px 130px;
    margin-inline: 16px;
    width: calc(100% - 32px);
  }
  @media (max-height: 832px) {
    padding-top: 8px;
  }
`

export const FlexDiv = styled.div`
  display: flex;
  .bottom-actions-container {
    width: 100%;
    display: flex;
    align-items: flex-end;
    justify-content: space-between;
  }
  .actions-container {
    display: flex;
    justify-content: space-between;
    align-items: flex-end;
  }
  &.section-footer {
    position: sticky;
    bottom: 0;
    background: white;
    padding: 8px 12px;
    width: 676px;
    justify-content: space-between;
    @media (max-width: 698px) {
      width: 90%;
    }
    /* Set only fixed only when using desktop and min-height */
    @media  (min-width: 768px) and (min-height: 780px) {
      position: unset;
    }
  }
  @media (max-width: 698px) {
    margin-inline: 16px;
  }
`

export const ActionButton = styled.div`
  background: ${({ secondary }: DivProps) => secondary ? '#D7D1D2' : BLACK_BG};
  font-weight: 500;
  font-family: Avenir;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 146px;
  height: 40px;
  border-radius: 25px;
  text-align: center;
  transition: all 0.25s;
  color: ${({ secondary }: DivProps) => secondary ? '#8F8889' : 'white'};
  &.close {
    background: white;
    border: 1px solid ${BLACK_BG};
    color: ${BLACK_BG};
    padding: 7px;
    width: 144px;
  }
  &:hover {
    cursor: pointer;
    box-shadow: 0px 1px 6px 0px #484848;
  }
  @media (max-width: 698px) {
    width: 130px;
  }
  .carousel-bottom-actions > &.close {
    @media (max-width: 320px) {
      width: 110px;
    }
  }
`

export const ManualStep = styled.div`
  max-width: 532px;
  #manualTitle {
    text-align: center;
    margin-block: 28px 20px;
    color: #111;
    font-size: 22px;
    font-weight: 600;
    line-height: 30.8px;
  }
  .inputs {
    width: 100%;
    background: #F7F7F7;
    padding: 20px 30px;
    border-radius: 8px;
  }
  #measureLink {
    flex: 1;
    text-decoration: underline;
    font-weight: 500;
    display: flex;
    align-items: flex-end;
    justify-content: center;
    cursor: pointer;
  }
  @media (max-width: 698px) {
    #warningManual {
      flex-flow: column;
      margin: 12px 22px;
    }
    #inputSection {
      flex-flow: column;
      align-items: center;
      background: #f7f7f7;
      padding-bottom: 14px;
    }
    #manualPhoto {
      margin-top: 10px;
    }
    #manualTitle {
      margin-block: 16px;
    }
    .inputs {
      width: unset;
      padding: unset;
    }
  }
  @media (max-width: 340px) {
    #manualTitle {
      font-size: 16px;
      margin-inline: 6px;
    }
  }
`

const selectFieldStyles = `
  appearance: none;
  width: 100%;
  padding: 12px 44px 12px 18px;
  border: 1px solid #D9D9D9;
  border-radius: 10px;
  background-color: #FFFFFF;
  font-size: 14px;
  color: #111;
  cursor: pointer;
  transition: border-color 0.2s ease;

  &:hover {
    border-color: #B8B8B8;
  }
  &:focus {
    outline: none;
    border-color: #111;
  }
  &:invalid {
    color: #817E7E;
  }
  &[data-has-error="true"] {
    border-color: red;
  }
  option {
    color: #111;
  }
  option:disabled {
    color: #9B9B9B;
  }
`

export const SelectWrapper = styled.div`
  position: relative;
  width: 100%;
  display: flex;
  align-items: center;
  margin-top: 8px;

  select {
    ${selectFieldStyles}
  }

  > .anticon {
    position: absolute;
    right: 16px;
    pointer-events: none;
    color: #302628;
    font-size: 12px;
  }
`

export const BodyMeasurementsSection = styled.div`
  width: 100%;
  padding-top: 28px;
  margin-top: 28px;
  border-top: 2px solid #E5E5E5;

  .sectionTitle {
    color: #625F5F;
    font-size: 10px;
    font-weight: 600;
    letter-spacing: 0.75px;
    text-transform: uppercase;
  }

  .sectionSubtitle {
    color: #817E7E;
    font-size: 14px;
    font-weight: 400;
    margin-top: 10px;
    line-height: 21px;
  }

  .grid {
    display: flex;
    flex-wrap: wrap;
    margin-top: 28px;
  }

  .field {
    display: flex;
    flex-direction: column;
    flex: 1 1 calc((100% - 32px) / 2);
    min-width: 240px;
    margin-right: 22px;
    margin-bottom: 28px;
    &:nth-child(even) {
      margin-right: 0;
    }
    &:nth-last-child(-n+2) {
      margin-bottom: 0;
    }
    @media (max-width: 768px) {
      border-radius: 8px;
      border: 1px solid #E8E5E5;
      background: #FFF;
      padding: 16px;
    }
  }

  .fieldHead {
    position: relative;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .fieldLabelUnit {
    display: none;
    @media (max-width: 768px) {
      display: inline-flex;
      margin-left: 4px;
      color: #302628;
      font-size: 14px;
      font-weight: 600;
      line-height: 20px;
    }
  }

  .ant-tooltip-inner {
    background-color: transparent;
    color: inherit;
    padding: 0;
    border-radius: 0;
    box-shadow: none;
    min-width: 0;
    min-height: 0;
  }

  .ant-tooltip-arrow {
    display: none;
  }

  .fieldLabel {
    color: #302628;;
    font-size: 14px;
    font-weight: 600;
    line-height: 20px; 
  }

  .howToLink {
    display: inline-flex;
    align-items: center;
    color: #34C759;
    font-size: 12px;
    font-weight: 600;
    letter-spacing: 0.3px;
    cursor: pointer;
    background: none;
    border: none;
    padding: 0;
    transition: color 0.2s ease;

    &:hover {
      color: #148A48;
      text-decoration: underline;
    }

    .anticon {
      font-size: 14px;
      color: inherit;
      margin-right: 6px;
    }
  }

  select {
    ${selectFieldStyles}
  }

  @media (max-width: 698px) {
    padding-top: 18px;
    margin-top: 20px;
    .grid {
      margin-top: 20px;
    }
    .field {
      flex: 1 1 100%;
      min-width: 0;
      margin-right: 0;
      margin-bottom: 0;
      margin-top: 20px;
      &:first-child {
        margin-top: 0;
      }
    }
    .fieldHead {
      flex-wrap: wrap;
    }
    .howToLink {
      margin-top: 14px;
      align-self: flex-end;
    }
  }
`

export const UnitsToggle = styled.div`
  display: flex;
  align-items: center;
  margin: 12px 0 18px;
  @media (max-width: 768px) {
    width: 90%;
  }

  .unitsLabel {
    color: #7F7F7F;
    font-weight: 600;
    font-size: 10px;
    margin-right: 18px;
    color: #625F5F;
    letter-spacing: 0.75px;
    text-transform: uppercase;
  }

  .switchPill {
    position: relative;
    display: inline-flex;
    align-items: center;
    background: #E2E0E0;
    border-radius: 100px;
    padding: 4px;
    height: 40px;
    user-select: none;
  }

  .opt {
    position: relative;
    z-index: 2;
    padding: 0 28px;
    width: 100%;
    text-align: center;
    line-height: 32px;
    font-size: 12px;
    font-weight: 600;
    color: #817E7E;
    pointer-events: none;
    transition: color 0.2s ease;
    &.active {
      color: #302628;
      font-weight: 600;
    }
  }

  .ant-switch {
    position: absolute;
    top: 4px;
    left: 4px;
    width: calc(100% - 8px);
    height: calc(100% - 8px);
    min-width: 0;
    background: transparent;
    border: none;
    border-radius: 100px;
    box-shadow: none;

    &:focus {
      box-shadow: none;
    }

    &::after {
      top: 0;
      left: 0;
      width: calc(50% - 2px);
      height: 100%;
      margin-left: 0;
      border-radius: 100px;
      background: #FFFFFF;
      box-shadow: 0 2px 6px #0000001f;
    }

    &.ant-switch-checked {
      background: transparent;
      &::after {
        left: 50%;
        margin-left: 50%;
      }
    }
  }

  @media (max-width: 768px) {
    .unitsLabel {
      display: none;
    }
    .switchPill {
      flex: 1;
      display: flex;
      justify-content: space-between;
    }
  }

  @media (max-width: 340px) {
    margin-right: 10px;
    .opt {
      padding: 0 18px;
      font-size: 13px;
    }
  }
`

export const ManualFieldsGrid = styled.div`
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  padding-top: 24px;
  margin-top: 24px;
  border-top: 2px solid #E5E5E5;

  .field {
    display: flex;
    flex-direction: column;
    flex: 1 1 calc((100% - 48px) / 3);
    min-width: 164px;
    margin-right: 20px;
    &:last-child {
      margin-right: 0;
    }
    @media (max-width: 698px) {
      margin-right: 0;
    }
  }

  .fieldLabel {
    color: #625F5F;
    font-size: 10px;
    font-weight: 600;
    letter-spacing: 0.75px;
    text-transform: uppercase;
    @media (max-width: 768px) {
      font-size: 10px;
      letter-spacing: 0.75px;
    }
  }

  .fieldLabelUnit {
    display: none;
    @media (max-width: 768px) {
      display: inline-flex;
      margin-left: 4px;
      color: #625F5F;
      font-size: 10px;
      font-weight: 600;
      letter-spacing: 0.75px;
      text-transform: uppercase;
    }
  }

  select {
    ${selectFieldStyles}
  }

  @media (max-width: 698px) {
    padding-top: 0;
    margin-top: 0;
    border-top: unset;
    flex-wrap: nowrap;
    .field {
      flex: 1 1 0;
      min-width: 0;
      margin-right: 8px;
      &:last-child {
        margin-right: 0;
      }
    }
  }
`

export const GuideTooltipContent = styled.div`
  border-radius: 8px;
  min-width: 434px;
  height: 180px;
`

export const GuideTooltipImage = styled.img`
  display: block;
  width: 434px;
  max-width: 100%;
  height: 182px;
`

export const GuideBottomSheetTip = styled.div`
  width: 36px;
  height: 4px;
  border-radius: 2px;
  background: #D7D1D2;
  margin-top: 12px;
`

export const GuideBottomSheetImage = styled.img`
  display: block;
  width: 100%;
  max-height: 60vh;
  object-fit: contain;
  background: #fff;
  padding: 16px;
`

export const SuccessScreen = styled.div`
  width: 100%;
  height: 70vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  font-family: Avenir;
  #successTitle {
    color: #111;
    font-size: 22px;
    font-weight: 600;
    padding: 12px;
    text-align: center;
  }
  #successSubtitle {
    margin-bottom: 32px;
    color: #000;
    text-align: center;
    font-size: 16px;
    line-height: 20px;
    @media (max-width: 698px) {
      font-size: 16px;
      padding-inline: 42px;
    }
  }
  #successActions {
    display: flex;
    justify-content: center;
    width: 100%;
    padding: 14px;
    font-size: 16px;
    font-weight: 600;
    font-family: "Avenir Next";
    @media (max-width: 698px) {
      flex-direction: column;
      align-items: center;
      font-size: 14px;
    }
    button {
      width: 100%;
      max-width: 280px;
      height: 40px;
      border-radius: 25px;
      margin-bottom: 16px;
      background: #000;
      color: #fff;
      cursor: pointer;
      margin-left: 24px;
      &[data-ghost="true"] {
        background: transparent;
        color: #000;
        border: 1px solid #000;
      }
    }
  }
  #successCard {
    display: flex;
    flex-flow: column;
    padding: 16px;
    justify-content: center;
    align-items: center;
    background: #F7F7F7;
    max-width: 260px;
    width: 100%;
    border-radius: 8px;
    margin-block: 32px;
  }
  #avatar {
    font-size: 38px;
    color: white;
    background: #00C7BE;
    border-radius: 50%;
    display: flex;
    height: 80px;
    width: 80px;
    align-items: center;
    justify-content: center;
    box-shadow: 6px 6px 30px #0000002e;
  }
  #name {
    color: #302628;
    margin-top: 16px;
    font-size: 18px;
    font-weight: bold;
  }
  #role {
    margin-top: 4px;
    text-transform: uppercase;
    font-weight: 500;
  }
  b {
    color: #111;
    font-size: 16px;
    font-weight: 600;
  }
`


// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--5!./src/screens/GetMeasured/styledComponents.tsx